export default "__VITE_ASSET__DhNgEGFR__"